(ns app.front.ui.accordion
  (:require [app.front.ui :as ui]
            [app.front.ui.expandable :as expandable]
            [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-sub ::accordion-section-state
  (fn [db [_ id section-counter]]
    (get-in db [::section-states id (str section-counter)])))

(rf/reg-event-db ::toggle-accordion-section
  (fn [db [_ id section-counter requested-state]]
    (if (some? requested-state)
      (assoc-in db [::section-states id (str section-counter) :collapsed?] requested-state)
      db)))

(defn- accordion-section [{:keys [id transition-duration transition-function initial-state *toggle-fns
                                  section-counter section-fn on-expand]}]
  [expandable/expandable
   {:state               (or (<sub [::accordion-section-state id section-counter])
                             {:collapsed? (if (and (= initial-state :first-open)
                                                   (= section-counter 0)) false true)})
    :toggle-state-fn     (fn [requested-state]
                           (rf/dispatch [::toggle-accordion-section id section-counter requested-state]))
    :transition-duration (or transition-duration 400)
    :transition-function (or transition-function "ease-in")
    :section-counter     section-counter
    :*toggle-fns         *toggle-fns
    :on-expand           on-expand}
   section-fn])

(defn accordion [id props section-fns]
  (r/with-let [*toggle-fns (when (seq section-fns) (atom (vec (repeat (count section-fns) nil))))]
    (let [id (futil/sanitize-id id)]
      (futil/for-frag [[section-fn section-counter] (mapv vector section-fns (range))]
        [accordion-section (merge props
                                  (util/mmap *toggle-fns id section-fn section-counter))]))))

(defn blue-header-accordion [id tr props sections]
  (let [transition-duration 400]
    [accordion id
     (merge props
            {:transition-duration transition-duration
             :transition-function "ease"})
     (for [{:keys [header-pill-text header-pill-color header-text header-info content]} sections]
       (fn [{:keys [collapsed? expandable-container-props toggle-and-close-others-fn]}]
         [:div.text-ui-night-sky-100.pt-2
          [:div.bg-ui-night-sky-100.text-ui-white.py-2.px-4.rounded.flex.justify-between.cursor-pointer
           {:on-click toggle-and-close-others-fn}
           [:div.flex
            (when header-pill-text
              [ui/pill
               {:color (or header-pill-color :white)
                :size  :small
                :text  header-pill-text}])
            [:h5.leading-normal header-text]]
           [:div.flex.flex.leading-normal
            header-info
            [:div.flex.pl-8
             {:role :button}
             [:span.mr-2 (if collapsed? (tr [:open]) (tr [:close]))]
             [:div.relative.top-0_5
              [cc/icon {:style       {:transition (str "transform " transition-duration "ms ease-in-out")
                                      :transform  (if collapsed? "scaleY(-1)" "scaleY(1)")}
                        :icon        i/chevron-up
                        :fill        "currentColor"
                        :width       "14"
                        :description (if collapsed? (tr [:open]) (tr [:close]))}]]]]]
          [:div
           (expandable-container-props)
           [:div.pt-2
            content]]]))]))
